import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

export const LoginPage = () => {
  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="eio-login" data-testid="login-page">
      <div className="eio-login-card">
        <div className="eio-login-title">CamelionAI EIOS</div>
        <div className="eio-login-sub">Founder access only · Executive Intelligence Operating System</div>
        <button className="btn-eio" onClick={login} data-testid="google-signin-btn">
          Sign in with Google
        </button>
        <div className="eio-login-note">Preview governance control · sessions expire after 7 days</div>
      </div>
    </div>
  );
};

export const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const r = await fetch(`${API}/api/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!r.ok) throw new Error((await r.json()).detail || "Sign-in failed");
        const user = await r.json();
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/app", { replace: true, state: { user } });
      } catch (e) {
        setError(String(e.message || e));
      }
    })();
  }, [location.hash, navigate]);

  if (error) {
    return (
      <div className="eio-login" data-testid="auth-error">
        <div className="eio-login-card">
          <div className="eio-login-title">Access denied</div>
          <div className="eio-login-sub">{error}</div>
        </div>
      </div>
    );
  }
  return <div className="eio-login" data-testid="auth-processing" />;
};

export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(location.state?.user ? true : null);

  useEffect(() => {
    if (location.state?.user) return;
    (async () => {
      try {
        const r = await fetch(`${API}/api/auth/me`, { credentials: "include" });
        if (!r.ok) throw new Error("not authenticated");
        await r.json();
        setIsAuthenticated(true);
      } catch {
        setIsAuthenticated(false);
      }
    })();
  }, [location.state]);

  if (isAuthenticated === null) return <div className="eio-login" data-testid="auth-checking" />;
  if (isAuthenticated === false) return <Navigate to="/login" replace />;
  return children;
};
